export default {
  citizen: {
    title: 'Citizen',
    feature: {
      participatory_surveys: {
        title: 'Participate in Surveys',
        description: 'Join local surveys and follow guides to identify species.',
      },
      data_collection: {
        title: 'Data Collection',
        description: 'Submit geolocated observations with photos and notes.',
      },
      territory_information: {
        title: 'Territory Information',
        description: 'Access local biodiversity and protected area data.',
      },
      statistics_visualization: {
        title: 'Statistics Visualization',
        description: 'Track local indicators like the number of recorded species.',
      },
    },
  },
  association: {
    title: 'Association',
    feature: {
      data_archiving: {
        title: 'Data Archiving',
        description: 'Store and publish your census data in a secure space.',
      },
      knowledge_sharing: {
        title: 'Knowledge Sharing',
        description: 'Access collaborative articles, guides, and case studies.',
      },
      public_awareness: {
        title: 'Public Awareness',
        description: 'Organize events to engage the public in your projects.',
      },
    },
  },
};
